import moment from 'moment-timezone';
import config from '../../config';
import { fetchM } from './fetchM';
import { handleError } from './error';
import {
  HIMS_DISTRICTS_REQUEST,
  HIMS_DISTRICTS_SUCCESS,
  HIMS_DISTRICTS_FAILURE,
} from '../constants/actions';

function himsDistrictsRequest() {
  return {
    type: HIMS_DISTRICTS_REQUEST,
  };
}

function himsDistrictsSuccess(data, token = null) {
  return {
    type: HIMS_DISTRICTS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function himsDistrictsError(message) {
  return {
    type: HIMS_DISTRICTS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchHimsDistricts(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    let himsDistrictsData = {};
    dispatch(himsDistrictsRequest());
    if (!fresh) {
      try {
        himsDistrictsData = JSON.parse(localStorage.getItem(`${config.get('appName')}.himsDistricts`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !himsDistrictsData.data ||
        config.get('version') !== himsDistrictsData.version ||
        moment().isAfter(moment(himsDistrictsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(himsDistrictsSuccess(himsDistrictsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/hims/districts/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          localStorage.setItem(`${config.get('appName')}.himsDistricts`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(himsDistrictsSuccess(data, token));
      })
      .catch((err) => {
        // reuse data from localStorage in case of error
        if (himsDistrictsData.data) {
          dispatch(himsDistrictsSuccess(himsDistrictsData.data));
          return Promise.resolve();
        }
        dispatch(handleError(err, himsDistrictsError));
        return Promise.reject(err);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/himsDistricts.js